import { SET_CHAT_DATA } from '../mutation-types';
const actions = {
    setChatData: ({ commit }, chat) => {
        commit(SET_CHAT_DATA, chat);
    },
};
export default actions;
